import { useState } from 'react';
import { forgotPassword } from '../api/auth/auth';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState<string | null>(null);

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (loading) return;
        setErr(null);
        setLoading(true);
        try {
            await forgotPassword(email.trim());
            setSent(true); // zawsze true (backend nie ujawnia, czy email istnieje)
        } catch (e: any) {
            setErr(e.message || 'Błąd');
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <main className="login-wrap">
                <section className="login-card">
                    <h1>Sprawdź skrzynkę</h1>
                    <p>Jeśli podany adres istnieje, wysłaliśmy wiadomość z linkiem do zresetowania hasła.</p>
                </section>
            </main>
        );
    }

    return (
        <main className="login-wrap">
            <section className="login-card">
                <h1>Przypomnij hasło</h1>
                <form onSubmit={submit} className="login-form">
                    <label className="login-label">
                        Email
                        <input className="login-input" type="email" value={email}
                            onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
                    </label>
                    {err && <p style={{ color: '#b91c1c' }}>{err}</p>}
                    <button className="login-button" type="submit" disabled={loading}>
                        {loading ? 'Wysyłanie…' : 'Wyślij link resetujący'}
                    </button>
                </form>
            </section>
        </main>
    );
}
